<template>
    <figure v-if="data" :class="[{ 'has-caption' : data.caption, 'background-image' : background }, 'size-'+size]" class="image-hold">
        <div  :class="{ 'useholder' : placeholder, 'hero-thumb' : hero }" class="wp-image lazyloading" >
        <img
            v-if="!background"
            :src="(lazy)? imagePlaceholder : fixedImageLink"
            :srcset="(lazy)? srcSet : '' "
            :data-src="fixedImageLink"
            :data-srcset="srcSet"
            :data-alt="data.alt"
            :class="{'lazyload' : lazy }" />
        <div v-else class="bg-image" :class="{'lazyload' : lazy }" :style="'background-image: url('+fixedImageLink+')'" ></div>
        <div class="lazy-placeholder" :style="'background-image: url('+imagePlaceholder+')'" v-if="placeholder" ></div>
        <slot class="slot-in" name="in"></slot>        
        </div>
        <figcaption v-if="(data.caption && caption) || (data.title && title)" role="description">
            <span v-if="title" class="title">{{ data.title }}</span>
            <span v-if="caption" class="caption">{{data.caption}}</span>
        </figcaption>
        <slot class="slot-out" name="out"></slot>
    </figure>

</template>

<script>
import _orderby from "lodash.orderby";

/**
 * Avable sizes:
 * min - 32
 * thumbnail - 150
 * medium - 300
 * medniu_large - 768
 * large - 1024
 * extra_large - 1920
 * full - full
 * Other: 
 * 1536x1536 - 1536
 * 2048x2048 - 2048
 */
export default {
    name: 'wp-image',
    props: { 
        data: [Boolean, Object], 
        size: { type: String, default: 'medium'},
        caption: { type: Boolean, default: false },
        title: { type: Boolean, default: false },
        lazy: {
            type: Boolean, default: false
        },
        placeholder: {
            type: Boolean, default: false
        },
        background: {
            type: Boolean, default: false
        },
        hero: {
            type: Boolean, default: false
        }
    },
	mounted: function() {
        const VM = this;
        // set avaible sizes
        if(VM.data && VM.data.sizes){
            const sizes = Object.keys(VM.data.sizes).map(k =>{
                if(typeof VM.data.sizes[k] === 'object'){
                    VM.data.sizes[k].name = k;
                }
                return VM.data.sizes[k]
            })
            VM.sizes = sizes
        }

        VM.imageUrl = VM.data.url

        
	},
	data() {
		return {
            imageUrl: '',
            sizes: null,

		};
    },
    computed: {
        imagePlaceholder(){
            let placeholder = this.getSizeByName('min')
            if(!placeholder){
                let placeholder = this.getSizeByName('thumbnail')
            }
            return placeholder
        },
        srcSet(){
            const VM = this;            
            let srcset = '';
            if(VM.data && VM.data.sizes)
            Object.keys(VM.data.sizes).map( key =>{
                    srcset += VM.data.sizes[key]['url']+' '+VM.data.sizes[key]['width']+'w, ';
            })
            return srcset;
        },
        fixedImageLink(){
            //console.log('size', this.size, this.getSizeByName(this.size))
            return this.getSizeByName(this.size)
        }
    },
    methods:{
        getSizeByName(name){
            let sizeFind = this.imageUrl;
            if(this.sizes){
                const sizeFindImage = this.sizes.find(e=>{
                    return e.name === name
                })
                if(sizeFindImage && sizeFindImage.url){
                    sizeFind = sizeFindImage.url
                }
            }

            return sizeFind;
        }
    }
};
</script>


<style lang="scss" scope>
.lazyloading{
    position: relative;
    overflow: hidden;
    img{
        //display: none;
        &.lazyload{
            //filter: blur(5px);   
        }
    }
    &.useholder{
        .lazyloaded{
            ~.lazy-placeholder{
                opacity: 0;
            }
        }
        
    }
    .lazy-placeholder{
        position: absolute;
        top: -8px;
        bottom: -8px;
        left: -8px;
        right: -8px;
        z-index: 20;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        filter: blur(8px);
        transition: opacity 0.2s ease-in-out;
        will-change: opacity;
        opacity: 1;
    }
}

.image-hold {
    .bg-image {
        padding-bottom: 56.25%;
    }
}

.bg-image{
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
</style>